import React from 'react';
import pick from 'lodash/pick';
import Slider from '@material-ui/core/Slider';
import { FieldProps } from './types';

const SliderField: React.FC<FieldProps> = ({
  value,
  name,
  form,
  settings = {}
}) => {
  const attributes = pick(settings, ['min', 'max', 'step']);

  const handleChange = (
    event: React.ChangeEvent<{}>,
    value: number | number[]
  ) => {
    form.setFieldValue(name, value);
  };

  return (
    <Slider
      {...attributes}
      name={name}
      value={+(value || 0)}
      onChange={handleChange}
      valueLabelDisplay="auto"
    />
  );
};

export { SliderField };
